"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchInstallStatus = fetchInstallStatus;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _InstallStatusConstants = require("ui-addon-scriptloader/installStatus/InstallStatusConstants");

var HUBSETTINGS_URL = '/settings/settings';

function fetchInstallStatus() {
  return _apiClient.default.get(HUBSETTINGS_URL).then(function (response) {
    var scriptLoaderInstallStatus = response.find(function (responseItem) {
      return responseItem.name === 'scriptLoaderInstallStatus';
    });
    return scriptLoaderInstallStatus ? scriptLoaderInstallStatus.value : _InstallStatusConstants.UNINSTALLED;
  }).catch(function () {
    return _InstallStatusConstants.ERROR;
  });
}